import { gql } from '@parkchirp/api-client';

export const GET_AVAILABLE_ZONES = gql`
    query getAvailableZones(
        $facilityId: String!
        $startTime: Date!
        $endTime: Date!
        $category: HourlyCategoryEnum
    ) {
        getAvailableZones(
            facilityId: $facilityId
            startTime: $startTime
            endTime: $endTime
            category: $category
        ) {
            id
            name
        }
    }
`;
